import GameHub from '../assets/projects/gamehub.JPG';
import Mosh from '../assets/projects/mosh.JPG';
import AutomationCamp from '../assets/projects/automationcamp.png';
import MonopolyRPG from '../assets/projects/monopoly-RPG.png';
import EcommerceDocs from '../assets/projects/ecommerce-shop/ecommerce-docs.png';
import NotFound from '../assets/projects/404.webp';

export const PROJECTS = [
  {
    id: 1,
    title: "TypeScript Application",
    demoLink: "https://ggaming-hub.netlify.app",
    codeLink: "https://github.com/BoronenkoTimurs/game-hub",
    backgroundImage: GameHub,
  },
  {
    id: 2,
    title: "HTML/CSS Application",
    demoLink: "https://moshexample.netlify.app",
    codeLink: "https://github.com/BoronenkoTimurs/firstWebPage",
    backgroundImage: Mosh,
  },
  {
    id: 3,
    title: "Automation Practice",
    demoLink: "https://play1.automationcamp.ir/",
    codeLink: "https://github.com/BoronenkoTimurs/automatization-PW",
    backgroundImage: AutomationCamp,
  },
  {
    id: 4,
    title: "Vanila JS Game - Monopoly RPG",
    demoLink: "https://sgames.x10.mx/",
    codeLink: "https://github.com/BoronenkoTimurs/monopoly-RPG-client",
    backgroundImage: MonopolyRPG,
  },
  {
    id: 5,
    title: "Ecommerce-shop project admin - NextJS",
    demoLink: "#",
    codeLink: "https://github.com/BoronenkoTimurs/ecommerce-admin",
    backgroundImage: NotFound,
  },
  {
    id: 6,
    title: "Ecommerce-shop project client - NextJS",
    demoLink: "#",
    codeLink: "https://github.com/BoronenkoTimurs/ecommerce-client",
    backgroundImage: NotFound,
  },
  {
    id: 7,
    title: "Ecommerce-shop project documentation",
    demoLink: "https://main-documentation.netlify.app/docs/intro",
    codeLink: "https://github.com/BoronenkoTimurs/ecommerce-documentation",
    backgroundImage: EcommerceDocs,
  },
  {
    id: 8,
    title: "Travel webpage parser - Server(Express)",
    demoLink: "#",
    codeLink: "https://github.com/BoronenkoTimurs/parsers-server",
    backgroundImage: NotFound,
  },
  {
    id: 9,
    title: "Travel webpage parser - Client(React)",
    demoLink: "#",
    codeLink: "https://github.com/BoronenkoTimurs/parser-client",
    backgroundImage: NotFound,
  },
];